/**
 * Resolves which top-level tab should be highlighted for a given pathname.
 *
 * Some routes (e.g. `/notifications`) are reached from a tab but are not
 * tabs themselves. Without an explicit mapping they would highlight no tab
 * (falling back to Home on mobile), which is misleading. This module keeps
 * that mapping in one place shared by `MobileTabBar` and `DesktopSideNav`.
 */

/** Routes that belong to a tab even though they aren't nested under it. */
const SECONDARY_ROUTES: ReadonlyArray<{ prefix: string; tabHref: string }> = [
  { prefix: '/notifications', tabHref: '/settings' },
];

export function resolveActiveTab(
  pathname: string,
  tabHrefs: ReadonlyArray<string>,
): string {
  // 1. Direct match against a tab href (exact, or nested under it).
  for (const href of tabHrefs) {
    if (href === '/dashboard') {
      if (pathname === '/dashboard') return href;
    } else if (pathname === href || pathname.startsWith(`${href}/`)) {
      return href;
    }
  }

  // 2. Secondary routes that map onto a tab.
  for (const { prefix, tabHref } of SECONDARY_ROUTES) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) {
      if (tabHrefs.includes(tabHref)) return tabHref;
    }
  }

  // 3. Fallback to the first tab (Home).
  return tabHrefs[0];
}
